let next = 0

class FieldFormater {
  constructor () {}

  init (inputs) {
    this.inputs = inputs
  }

  check (inputs) {
    if (this.value.length === 2) {
      if (this.name === 'cc_expiration') {
        this.value = `${this.value}/`
      }
    }

    if (this.value.length === this.maxLength) {
      if (next + 1 < inputs.length) {
        next++
        if (this.name === 'cc_expiration') {
          if (this.value.search('/') === -1) {
            const newValue = `${this.value.replace(/\//g, '').substring(0, 2)}${
              this.value.length > 2 ? '/' : ''
            }${this.value.replace(/\//g, '').substring(2, 4)}`
            this.value = newValue
          }
          //this.select()
        }
        inputs[next].focus()
      } else {
        inputs[next].blur()
      }
    }
  }
}

export const format = new FieldFormater()
